import React from 'react';
import { Row, Col } from 'antd';
import { BInput } from 'common/components';

const Signers = ({ fullName, position }) => {
  return (
    <>
      {fullName ? (
        <Row>
          <Col span={8}>
            <BInput
              disabled
              isRequired
              className="form-add-user-input"
              name="fullNameSigner"
              defaultValue={fullName}
              label="Nombre completo del firmante:"
            />
          </Col>

          <Col span={8}>
            <BInput
              disabled
              isRequired
              className="form-add-user-input"
              name="positionSigner"
              defaultValue={position}
              label="Posición:"
            />
          </Col>
        </Row>
      ) : (
        <Row>
          <Col span={8}>
            <BInput
              disabled
              isRequired
              className="form-add-user-input"
              label="Nombre completo del firmante:"
            />
          </Col>

          <Col span={8}>
            <BInput disabled isRequired className="form-add-user-input" label="Posición:" />
          </Col>
        </Row>
      )}
    </>
  );
};

export default Signers;
